import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name:'timeAgo'
})
export class TimeAgoPipe implements PipeTransform{
    transform(value:string) {
        let d = new Date(value);
        let now = new Date();
        let seconds = Math.round(Math.abs((now.getTime() - d.getTime())/1000));
        let minutes = Math.round(Math.abs(seconds / 60));
        let hours = Math.round(Math.abs(minutes / 60));
        let days = Math.round(Math.abs(hours / 24));
        if (Number.isNaN(seconds)){
            return '';
        }else if (days < 1 && hours <= 23) {
            return 'today';
        }else if (days < 2 && hours <= 47) {
            return 'yesterday';
        }else if (days >= 2) {
            return days + ' days ago';
        }
    }
}